import axios from 'axios';
import React, { useEffect, useState } from 'react';
import colors from '../../../css/colors';
import withUser from '../../../lib/WithUser';
import WithDocumentStation from '../ui/DocumentStation/WithDocumentStation';
import TextArea from '../ui/TextArea';
import withProperty from '../WithProperty';
import { toolTip, toolTipWrap } from '../SharedFormStyles';
import ActionButton from '../../ui/ActionButton';
import { textBoxStyles } from '../TaxSearches/NycTaxSearch/styles';
import SaveAndHoldButton from '../SaveAndHoldButton';
import SubmitFormButton from '../SubmitFormButton';
import CurrencyField from 'components/ui/CurrencyField';
import BinaryRadioButton from '../ui/BinaryRadioButton';
import Dropdown from '../../ui/Dropdown';
import ReusableTopOfForm from '../ReusableTopOfForm';

const searchTypeId = 84;

export interface MuniOption {
  id: number;
  name: string;
}
var muniOptions = [
  {
    id: 1,
    name: 'County',
  },
  {
    id: 2,
    name: 'Municipality',
  },
  {
    id: 3,
    name: 'Submunicipality',
  },
];

const BuildingPlans = (props: any) => {
  const [searchId, setSearchId] = useState(0);
  const [additionalInformation, setAdditionalInformation] = useState<string>('');
  const [pdfHtml, setPdfHtml] = useState();
  const [loaderStatus, setLoaderStatus] = useState(false);
  const [searchHeader, setSearchHeader] = useState('');
  const [townFee, setTownFee] = useState(null);
  const [buildingPlans, setBuildingPlans] = useState(false);
  const [selectedMuniLevel, setSelectedMuniLevel] = useState<MuniOption>();
  const params = new URLSearchParams(props.location.search);
  const isEdit = params.get('isEdit');

  useEffect(() => {
    axios
      .get(`/api/searches/GetSearchByType/${searchTypeId}/${+props.match.params.propertyid}`)
      .then(({ data }) => {
        props.setSearchId(data.id);
        setSearchId(data.id);
      });
    axios
      .get(`/api/searches/getSaved?propertyId=${+props.match.params.propertyid}&searchTypeId=${searchTypeId}`)
      .then(({ data }) => {
        if (data) {
          setAdditionalInformation(data.text);
          setSearchHeader(data.searchHeader);
          setTownFee(data.townFee);
          setBuildingPlans(data.buildingPlans);
        }
      });
  }, []);

  const handlePreview = async () => {
    const { data: html } = await axios.post('/api/searches/CreatePDF', {
      template: 'MiscSearch',
      data: {
        text: additionalInformation,
        propertyId: +props.match.params.propertyid,
        searchTypeId,
        searchType: 'Building Plans',
        searchHeader: 'Building Plans',
        runDate: props.runDate,
        buildingPlans,
        customText: buildingPlans ? 'See the attached Building Plans.' : 'No Building Plans Available.',
        townFee,
      },
    });
    setPdfHtml(html);
  };

  const handleDownload = async () => {
    setLoaderStatus(true);
    await axios.post('/api/searches/DownloadPDF', {
      template: 'MiscSearch',
      data: getFormContent(),
    });
    const feeToPost = [
      {
        fee: townFee,
        searchId,
        orderId: props.property.orderId,
        sendToCounty: selectedMuniLevel?.name === 'County',
        sendToMuni: selectedMuniLevel?.name === 'Municipality',
        sendToSubmuni: selectedMuniLevel?.name === 'Submunicipality',
      },
    ];
    await axios.post('/api/searches/updateSearchFees', feeToPost);
    props.history.push(`/orders/order-information/${props.property.orderId}`);
    setLoaderStatus(false);
  };
  const getFormContent = () => {
    return {
      text: additionalInformation,
      propertyId: +props.match.params.propertyid,
      searchTypeId,
      searchType: 'Building Plans',
      searchHeader: 'Building Plans',
      runDate: props.runDate,
      buildingPlans,
      customText: buildingPlans ? 'See the attached Building Plans.' : 'No Building Plans Available.',
      townFee,
    };
  };
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ width: '50%' }}>
        <ReusableTopOfForm
          handlePreview={handlePreview}
          searchHeader="Building Plans"
          propertyId={props.match.params.propertyid}
          searchTypeId={searchTypeId}
          property={props.property}
          getFormContent={async () => ({
            text: additionalInformation,
            propertyId: +props.match.params.propertyid,
            searchTypeId,
            searchType: 'Building Plans',
            searchHeader: 'Building Plans',
            runDate: props.runDate,
            customText: buildingPlans ? 'See the attached Building Plans.' : 'No Building Plans Available.',
            townFee,
          })}
          template="MiscSearch"
          searchId={searchId}
        />
        {/* <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h1 style={{ marginBottom: 32 }}>Building Plans</h1>
          <div style={{ position: 'fixed', right: 70, top: 220, zIndex: 500 }}>
            <div css={toolTipWrap}>
              <ActionButton icon="PreviewIcon" backgroundColor={colors.blackText} onClick={handlePreview} />
              <span css={toolTip}>
                Preview
                <span />
              </span>
            </div>
          </div>
        </div> */}
        {searchId > 0 && <WithDocumentStation searchId={searchId} />}
        <BinaryRadioButton
          headerText="Are there Building Plans?"
          trueText="Building Plans found, see attached"
          falseText="No Building Plans"
          checkedState={buildingPlans}
          onChange={() => setBuildingPlans(!buildingPlans)}
        />
        <Dropdown
          label="Town Fee Recipient"
          value={selectedMuniLevel?.name || 'Select Town Fee Recipient'}
          selectedId={selectedMuniLevel?.id || null}
          itemList={muniOptions}
          onClick={(item: any) => {
            setSelectedMuniLevel(item);
          }}
        />
        <CurrencyField
          width="296px"
          label="Town Fee"
          styles={{ marginTop: 24 }}
          placeholder=""
          value={townFee}
          onChange={e => setTownFee(e)}
        />
        <div style={{ marginTop: 24 }}>
          <TextArea
            value={additionalInformation}
            onChange={(e: any) => setAdditionalInformation(e.target.value)}
            label="Additional Information"
            placeholder="Note"
            styles={textBoxStyles}
            error={undefined}
            maxLength={undefined}
          />
        </div>
        <div
          style={{
            marginTop: 43,
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <SaveAndHoldButton
              propertyId={+props.match.params.propertyid}
              searchTypeId={searchTypeId}
              formData={() => {
                return {
                  text: additionalInformation,
                  propertyId: +props.match.params.propertyid,
                  searchTypeId,
                };
              }}
              afterSubmitRoute={() =>
                props.history.push(`/orders/order-information/${props.property.orderId}`)
              }
              userId={props.user.id}
              orderId={props.property.orderId}
              disabled={loaderStatus}
            />
            <div style={{ marginLeft: 8 }}>
              <SubmitFormButton
                searchTypeId={searchTypeId}
                onSubmit={handleDownload}
                propertyId={+props.match.params.propertyid}
                reactFormal={false}
                userId={props.user.id}
                orderId={props.property.orderId}
                loadingStatus={loaderStatus}
                buttonText={`${isEdit ? 'Save' : 'Submit'}`}
                getFormContent={getFormContent}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          width: '100%',
          borderStyle: 'solid',
          borderWidth: 2,
          padding: 16,
          position: 'sticky',
          top: 25,
          marginLeft: 24,
        }}
      >
        <iframe style={{ width: '100%', height: '100%' }} srcDoc={pdfHtml} />
      </div>
    </div>
  );
};
export default withProperty(withUser(BuildingPlans), searchTypeId, true);
